// src/components/PackageCard.jsx
import { Link } from 'react-router-dom';
import { Eye, Zap, Package as PackageIcon } from 'lucide-react';
import config from '../config';

export const PackageCard = ({ package: pkg }) => {
  const powerDisplay = pkg.power_display || `${pkg.power_value || pkg.power_rating} کیلووات`;

  const finalPrice = pkg.discount_price || pkg.total_price;
  const originalPrice = pkg.total_price;
  const hasDiscount = originalPrice && finalPrice && originalPrice > finalPrice;

  const renderPrice = () => {
    if (pkg.show_price_on_call) {
      return (
        <div className="flex flex-col">
          <span className="text-sm text-green-600 font-medium">تماس برای قیمت</span>
          <span className="text-xs text-gray-400">مشاوره رایگان</span>
        </div>
      );
    }

    if (!finalPrice && !originalPrice) {
      return (
        <span className="text-sm text-gray-500">قیمت نامشخص</span>
      );
    }

    return (
      <div>
        {hasDiscount && (
          <span className="text-gray-400 line-through text-xs block">
            {Number(originalPrice).toLocaleString('fa-IR')} تومان
          </span>
        )}
        <span className="text-xl font-bold text-blue-600">
          {Number(finalPrice).toLocaleString('fa-IR')} تومان
        </span>
      </div>
    );
  };

  const itemsCount = pkg.items?.length || 0;

  let imageUrl = null;
  if (pkg.image) {
    imageUrl = pkg.image.startsWith('http') ? pkg.image : config.getMediaUrl(pkg.image);
  }

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 group flex flex-col">
      <Link to={`/packages/${pkg.slug}`} className="block">
        <div className="relative h-48 bg-gradient-to-r from-blue-500 to-purple-600">
          {imageUrl && (
            <img
              src={imageUrl}
              alt={pkg.name}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.style.display = 'none';
              }}
            />
          )}

          {/* برچسب توان */}
          <div className="absolute top-2 right-2 bg-yellow-500 text-white px-2 py-1 rounded-full text-sm font-bold flex items-center gap-1 z-10">
            <Zap className="w-3 h-3" />
            {powerDisplay}
          </div>

          {/* ✅ برچسب "تماس برای قیمت" - به صورت تگ ساده (نه دکمه) */}
          {pkg.show_price_on_call && (
            <div className="absolute top-2 left-2 bg-green-500 text-white px-3 py-1 rounded-full text-xs font-bold z-10">
              تماس برای قیمت
            </div>
          )}

          {/* برچسب تخفیف */}
          {hasDiscount && !pkg.show_price_on_call && (
            <div className="absolute top-2 left-2 bg-red-500 text-white px-2 py-1 rounded-full text-xs font-bold z-10">
              {pkg.discount_percent}% تخفیف
            </div>
          )}

          {/* برچسب ویژه */}
          {pkg.is_featured && !hasDiscount && !pkg.show_price_on_call && (
            <div className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded-full text-xs font-bold z-10">
              ویژه
            </div>
          )}
        </div>
      </Link>

      <div className="p-4 flex flex-col flex-grow">
        <Link to={`/packages/${pkg.slug}`}>
          <h3 className="text-lg font-bold mb-1 hover:text-blue-600 transition line-clamp-2">{pkg.name}</h3>
        </Link>
        <p className="text-gray-500 text-sm mb-3 line-clamp-2">
          {pkg.short_description || pkg.description?.replace(/<[^>]*>/g, '').substring(0, 150) || 'توضیحاتی برای این پکیج...'}
        </p>

        <div className="flex items-center gap-1 text-xs text-gray-400 mb-2">
          <PackageIcon className="w-3 h-3" />
          <span>{itemsCount} محصول</span>
        </div>

        <div className="flex items-center justify-between mt-3 pt-2 border-t">
          <div>
            {renderPrice()}
          </div>

          <Link
            to={`/packages/${pkg.slug}`}
            className="bg-blue-600 text-white px-3 py-1.5 rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1 transition"
          >
            <Eye className="w-4 h-4" />
            مشاهده
          </Link>
        </div>
      </div>
    </div>
  );
};